import { EmployeeEditFormValues } from '@/core/domain/enterprise/Employees/Employees.types';
import { removeMask } from '@/utils/mask';

type Callback = (values: EmployeeEditFormValues) => Promise<unknown>;

export default async function handlerPersonalUpdate(
  values: EmployeeEditFormValues,
  callback: Callback,
) {
  let obj: EmployeeEditFormValues = {
    ...values,
    cpf: removeMask(values.cpf),
    rg: removeMask(values.rg),
  };

  const { photo } = values;

  if (photo && photo.length) {
    obj = {
      ...obj,
      photo: photo[0].response?.filePath || photo[0].url,
    };
  } else {
    obj = { ...obj, photo: null };
  }

  await callback(obj);
}
